module.exports = __webpack_public_path__ + "static/img/zx-wxzx-icon.3e9682e3.png";